import { useQuery } from "@tanstack/react-query";
import { authFetch } from "../../HttpClient";

// Déclenché à l'ouverture de la vue Archive (pas un cron) : demande au
// backend de marquer "archive_auto" les LM créées depuis + de 30 jours,
// non déjà archivées, puis renvoie la liste mise à jour.
export function useAutoArchiveDocuments() {
  return useQuery({
    queryKey: ["documents-auto-archive"],
    queryFn: async () => {
      const res = await authFetch(
        "https://backend-myalfa.vercel.app/api/documents-auto-archive",
        { method: "POST" }
      );
      if (!res.ok) throw new Error("Erreur lors de l'archivage automatique");
      return res.json();
    },
    staleTime: 5 * 60 * 1000,
  });
}
